import _ from 'lodash';

/**
 * Paths to the Edge RPC Handlers
 *
 * Notice that both keys and values have to be unique.
 * All keys has to be prefixed with the suite, which the service belongs to.
 *
 * Example:
 *   The handler PolicyHandler in PolicyCenter has the path 'policy/policy'.
 *   Then the key for this path is prefixed with PC_.
 *
 */
export enum capability {
    PC_POLICY = 'policy/policy',
    PC_POLICY_CHANGE = 'policychange/policychange',
    PC_USER_QUOTE = 'userquote/userquote',
    PC_QUOTE = 'quote/quote',
    PC_USER_INFO = 'userinfo',
    PC_INSURANCE_COMPANY_LOOKUP = 'insurancecompany/lookup',
    PC_ACTIVITY = 'activity/activityTop',
    PC_ONLINESALES = 'onlinesales/onlinesales',
    PC_ACTIVATIONFLOW = 'activationflow/activationflow',
    PC_ONLINESALES_UNAUTHENTICATED = 'onlinesales/unauthenticated',
    BC_BILLING_DATA = 'billing/billingData'
}

/**
 * This method will take the service name and the endpoints.
 * Then it will analyze the prefix of the used key in the capability object.
 *
 * Example:
 *   If the service is 'policy/policy', then you have used the PC_POLICY key.
 *   Then the endpoint for 'PC' is returned.
 *
 * @param service
 * @param endpoints
 */
export function getSuiteEndpoint(service: capability, endpoints: object) {
    const selected = Object.keys(capability).find((key) => capability[key as keyof typeof capability] === service);
    if (selected) {
        const suite = selected.substring(0, 2);
        if (_.has(endpoints, suite)) {
            return endpoints[suite as keyof typeof endpoints];
        }
    }
    return '';
}
